import { t } from '@lingui/macro';

export const title = t`Users`;

export default function UserFilterStateServiceFactory(filterId) {
    const UserFilterStateService = {
        /*
         * Factory functions
         */

        createWithEncodedState(encodedState) {
            return UserFilterStateService.decode(encodedState);
        },

        createWithDefaultState() {
            return {
                inverted: true,
                selection: [],
            };
        },

        createState(encodedFilterState, dataService) {
            const encodedState = encodedFilterState?.[filterId];
            return encodedState
                ? this.createWithEncodedState(encodedState, dataService)
                : this.createWithDefaultState(dataService);
        },

        /*
         * Transformation functions
         */

        parameterize(state) {
            return state.inverted
                ? ''
                : {
                      users: Array.isArray(state?.selection) ? state.selection.join(',') : '',
                  };
        },

        encode(state) {
            return JSON.stringify(state);
        },

        decode(encodedState) {
            return JSON.parse(encodedState);
        },

        summarize(state) {
            const { inverted, selection, names } = state;

            if (inverted) {
                return { title, value: t`All Users`, shortValue: t`All Users` };
            }

            if (selection.length === 0) {
                return { title, value: t`No User selected`, shortValue: t`None` };
            }

            const summary = names.join(', ') + t`(${names.length} selected)`;

            return { title, value: summary, shortValue: summary };
        },
    };

    return UserFilterStateService;
}
